import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavigationBar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
//import Safety from "./pages/Safety";
import Products from "./pages/Products";
// import Support from "./pages/Support";
//import About from "./pages/About";
import Contact from "./pages/Contact";
// import Material from "./pages/Material";
import FloatingButtons from "./components/FloatingButtons"; // Import FloatingButtons
import About from "./pages/About";
import Services from "./pages/Services";


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <NavigationBar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            
            <Route path="/products" element={<Products />} />
            {/* <Route path="/Support" element={<Support />} /> */}
            {/* <Route path="/material" element={<Material />}></Route> */}
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<Services />}/>
          </Routes>
        </main>
        <FloatingButtons /> {/* This ensures buttons are always visible */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
